import React from 'react'
import PT from 'prop-types'
import linkStore from '@vimcar/shared-utils/linkStore'

import i18n from '#utils/i18n'
import IntroOption from './components/IntroOption'
import mkStore from './store'
import styles from './styles.css'

const tp = i18n.prefix('components.CreateBooking')

const CreateBookingIntro = ({ store }) => (
  <div className={styles.introContainer}>
    <div className={styles.introOptionsWrapper}>
      <IntroOption
        actionText={tp('choose-simplified-booking')}
        caption={tp('simplified-booking-tooltip')}
        className={styles.introOption}
        icon='timer'
        onChangeCheckbox={store.handleCheckSimplified}
        onSubmit={store.handleSimplifiedSubmit}
        optionChecked={store.simplifiedChecked}
        saveOptionText={tp('save-as-default')}
        title={tp('simplified-booking')}
        />
      <IntroOption
        actionText={tp('choose-calendar-booking')}
        caption={tp('calendar-booking-tooltip')}
        className={styles.introOption}
        icon='calendar'
        onChangeCheckbox={store.handleCheckCalendar}
        onSubmit={store.handleCalendarSubmit}
        optionChecked={store.calendarChecked}
        saveOptionText={tp('save-as-default')}
        title={tp('calendar-booking')}
        />
    </div>
  </div>
)

CreateBookingIntro.propTypes = {
  store: PT.shape({
    simplifiedChecked: PT.bool.isRequired,
    calendarChecked: PT.bool.isRequired,
    handleCheckSimplified: PT.func.isRequired,
    handleCheckCalendar: PT.func.isRequired,
    handleSimplifiedSubmit: PT.func.isRequired,
    handleCalendarSubmit: PT.func.isRequired,
  }),
}

export default linkStore(mkStore, CreateBookingIntro)
